import * as Account from './components/Account/Account.css';
import * as Checkout from './components/Checkout/Checkout.css';
import * as ActionButton from './components/ActionButton/ActionButton.css';
const theme = {
    Warnings: {
        WarningsStyles: {
            warning: Account.warning,
            warning__text: Account.warning__text,
            warning__icon: Account.warning__icon
        }
    },
    Account: {
        Account: {
            card: Account.card,
            social__networks: Account.social__networks
        }
    },
    AccountModule: {
        Account: {
            card: Account.card
        }
    },
    Traveller: {
        Traveller: {
            wrapper: Account.card
        }
    },
    Input: {
        Input: {
            real_input: Checkout.input,
            input: Checkout.input
        }
    },
    Sidebar: {
        MobileMenu: {
            wrapper: Account.mobileMenu__wrp,
            title: Account.mobileMenu__title
        },
        Sidebar: {
            sidebar: Account.sidebar
        }
    },
    LoginPage: {
        RegistrationForm: {
            checkbox: Checkout.checkbox,
            checked: Checkout.checkbox_checked
        }
    },
    Button: {
        ActionButton: {
            button: ActionButton.button
        },
        WhiteButton: {
            button: ActionButton.white
        }
    }
};
export default theme;
